import * as React from 'react';
// import { RoutingFeatures } from '../../../../navigation/routingfeature';
import './featured-tone-card-style.css';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { AudioPlayerWithProgressHandler, AudioPlayerWithProgress } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { PlayerHandler } from 'src/com/sixdee/crbtportal/utils/player/playmanager';
import { DropdownRowViewModelHandler } from '../../../../toolkit/dropdownlist/dropdownrow/dropdownviewmodel';
import { PlayerWithProgressComponent } from '../../../../toolkit/player/playerwithprogress/playerwithprogress';
import { ImageLoaderCSSStyle } from '../../../../toolkit/imageloader/imageloadercss';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { ToneOptionDropDownRowViewModelImpl } from './tonecard/toneoptions/toneoptiondropdownlistviewmodel';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ToneCardImageLoaderCSSStyleImpl } from './tonecard/tonecardimageloadercss';
import { ToneEvenCardImageLoaderCSSStyleImpl } from './tonecard/toneevencardimageloader';
import { ToneMobileCardImageLoaderCSSStyleImpl } from './tonecard/tonemobilecardimageloadercss';
import { ToneMobileEvenCardImageLoaderCSSStyleImpl } from './tonecard/tonemobileevencardimageloader';
import { ToneCardComponentProps, ToneCardComponentState, ToneCardComponentHandler } from './tonecard/tonecardcomponent';
import { ToneCardCSSStyle } from './tonecard/tonecardcssstyle';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ImageLoaderComponent } from '../../../../toolkit/imageloader/imageloadercomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { DropDownListComponent } from '../../../../toolkit/dropdownlist/dropdownlistcomponent';
import { ToneOptionDropDownListCSSStyleImpl } from './tonecard/toneoptions/toneoptiondropdownlistcss';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { BuyToneComponent } from '../../../popup/buytone/buytonecomponent';
import { ToneOptionsType } from '../../../popup/tonedetailspopup/tonedetailspopupcomponent';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { GiftAFriendComponent } from '../../../popup/giftafriend/giftafriendcomponent';
import { ShareToneComponent } from '../../../popup/sharetone/sharetonecomponent';
import { TellAFriendComponent } from '../../../popup/tellafriend/tellafriendcomponent';
import { SubscriptionPlanComponent } from '../../../popup/subscription_plan/subscriptionplancomponent';
import { OTPVerificationComponent } from '../../../popup/otpverification/otpverificationcomponent';
import { MSISDNValidationComponent } from '../../../popup/msisdnvalidation/msisdnvalidationcomponent';
import { DeleteConfirmComponent } from '../../../popup/deleteconfirmation/deleteconfirmationcomponent';
import { RoutingFeatures } from '../../../navigation/routingfeature';
import { DropDownDto, DropDownDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto';


export class FeaturedCategoryToneCardViewImpl extends UIComponentViewImpl<UIDataModel> implements AudioPlayerWithProgressHandler, PlayerHandler, DropdownRowViewModelHandler
{
    private playerComponent: PlayerWithProgressComponent | null;
    private initialStateOfTonePlaying: boolean;
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private imageMobileLoaderCSSStyle: ImageLoaderCSSStyle;
    private evenMobileImageLoaderCSSStyle: ImageLoaderCSSStyle;
    private loaderWrapperComponent:LoaderWrapperComponent;
    // private playerCSSStyle: PlayerComponentCSSStyle;
    private popUpComponent: PopUpWrapperComponent;
    private listViewModel: ToneOptionDropDownRowViewModelImpl;
    private audioPlayerWithProgress: AudioPlayerWithProgress;
    // private cardCSSStyle : ToneCardCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.imageLoaderCSSStyle = new ToneCardImageLoaderCSSStyleImpl(context);
        this.evenImageLoaderCSSStyle = new ToneEvenCardImageLoaderCSSStyleImpl(context);
        // this.playerCSSStyle = new ToneCardPlayerCSSStyleImpl(context);
        this.imageMobileLoaderCSSStyle = new ToneMobileCardImageLoaderCSSStyleImpl(context);
        this.evenMobileImageLoaderCSSStyle = new ToneMobileEvenCardImageLoaderCSSStyleImpl(context);
        this.listViewModel = new ToneOptionDropDownRowViewModelImpl(true, context, this);
    }

    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
        this.onHovered = this.onHovered.bind(this);
        this.onHoveredExit = this.onHoveredExit.bind(this);
        this.onActionHovered = this.onActionHovered.bind(this);
        this.onActionHoveredExit = this.onActionHoveredExit.bind(this);
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
        this.onBuyToneClicked = this.onBuyToneClicked.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.getLikeCount = this.getLikeCount.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showToneOptionsPopup = this.showToneOptionsPopup.bind(this);
        this.onTryAgainClick = this.onTryAgainClick.bind(this);
        this.onSettingsClicked = this.onSettingsClicked.bind(this);
        this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onDeleteSuccess = this.onDeleteSuccess.bind(this);
        this.login = this.login.bind(this);
        this.onBuySuccess = this.onBuySuccess.bind(this);
    }


    draw(props: ToneCardComponentProps, state: ToneCardComponentState, cssStyle: ToneCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        this.listViewModel.setListDatas(this.getListOfDropDown(props.context));
       
        return (
            <>
              <div id="featured-tone-card-wrapper">
                                {
                                    this.getWebView(props, state, cssStyle)
                                }
                    </div>
                    
              {/* <div id="featured-tone-card-col-wrapper">
                                {
                                    this.getMobileView(props, state, cssStyle)
                                }
                </div>
                <div id="tonecard-col2-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div> */}

            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }


    getWebView(props: ToneCardComponentProps, state: ToneCardComponentState, cssStyle: ToneCardCSSStyle)
    {
        return (
           <>
            <div id="featured-tone-card-main-wrapper" key={props.position} style={props.cardStyle.getToneWrapperCSSStyle(props.marginTop)}>
                {
                    <>
                       <div id="featured-tone-extra-option-web">
                           {
                               <> 
                               {this.getToneExtraOptionsPart(props.cardStyle, state, props)}
                               {state.isActionHovered && this.getToneOptionsPart(cssStyle, state)}
                                </>
                            }    
                       </div>
                       <div id="featured-tone-extra-option-mobile">
                           {
                               <>
                               {this.getMobileToneExtraOptionsPart(props.cardStyle, state, props)}
                               {state.isActionHovered &&  this.getMobileToneOptionsPart(cssStyle, state)}
                                </>
                            }    
                       </div>
                    </>
                }     
                
                {/* <img ref={(item: any) => {this.img = item;}} onError={this.onImgError} alt="" src={props.toneDto.getImgPath()} style={cssStyle.getImgCSSStyle()}/>    */}
                {
                  <>  
                    <div id="image-loader">
                        {
                                 this.getWebImageLoader(props)
                        }
                    </div>    
                    <div id="image-col-loader">
                        {
                                this.getMobileImageLoader(props)
                        }
                    </div>    
                  </> 
                }
                {state.toneRowOptionsPrivilage.isPlay() && <PlayerWithProgressComponent isAutoPlayRequired={props.isPlayInitial} position={props.position}  id={props.toneDto.getId()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={props.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>}
                <div id="featured-tone-card-details" style={props.cardStyle.getDetailsDivCssStyle()}>
                   {props.toneDto.getArtistName() !== "" && 
                   <div id="featured-tone-card-title" style={props.cardStyle.getTitleDivCSSStle()}>
                        {/* style={{height: "30px", overflow: "hidden",marginTop:'7px',marginBottom:'3px'}} */}
                     <div id="featured-tone-card-tonename-div">
                        <label title={props.toneDto.getToneName()} id="featured-tone-card-tonename-label" style={props.cardStyle.getToneNameCSSStyle()}>{props.toneDto.getToneName()}</label>
                     </div>
                     {/* style={{height: "20px", overflow: "hidden"}} */}
                     <div id="featured-tone-card-artistname-div" >
                        <label title={props.toneDto.getArtistName()} id="featured-tone-card-artistname-label" style={cssStyle.getArtistNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
                     </div>
                  </div>
                   }
                   {props.toneDto.getArtistName() === "" && 
                   <div id="featured-tone-card-title" style={props.cardStyle.getTitleDivCSSStle()}>
                       {/* style={{height: "30px", overflow: "hidden",marginTop:'30px',marginBottom:'3px'}} */}
                     <div id="featured-tone-card-tonename-div" >
                        <label id="featured-tone-card-tonename-label" style={props.cardStyle.getToneNameCSSStyle()}>{props.toneDto.getToneName()}</label>
                     </div>
                  </div>
                   }
                    <div id="featured-tone-card-button" style={cssStyle.getButtonCSSStyle()} >
                        {
                            <>
                            <div id="button-div">
                                {/* {<>
                                     <div style={{width:'24px', height:'100%', marginLeft: !state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '40px' : "0px", marginRight:!state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '0px' : "20px"}}>
                                     {state.toneRowOptionsPrivilage.isGift() && <img title={props.context.getResources().getString(Strings.gift_a_friend)} onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} width='100%' height='100%' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>}
                                     </div>
                                     {state.toneRowOptionsPrivilage.isSettings() && <img  onClick={this.onSettingsClicked} src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='24px' height='100%'/>}
                                     {state.toneRowOptionsPrivilage.isBuy() && <img title={props.context.getResources().getString(Strings.buytone)} onClick={this.onBuyToneClicked} src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='24px' height='100%'/>}
                               </>} */}
                                                                    {/* /* {this.listViewModel.getListOfDatas().length === 1 && state.toneRowOptionsPrivilage.isDelete() && <img  onClick={this.onDeleteClicked} src={this.getUIProps().context.getResources().getImage("delete_trash_gray.svg")} width='24px' height='100%'/>} */} 
                                  {<>
                                    {state.toneRowOptionsPrivilage.isGift() &&<div onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} id="featured-gift-tone-card-option-div">
                                             <img id="featured-gift-tone-card-option-icon"  width='22px' height='22px' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>
                                            <label id="featured-gift-tone-card-option-label">{this.getContext().getResources().getString(Strings.gift)}</label>
                                      </div>}  
                                      {state.toneRowOptionsPrivilage.isBuy() &&  <div onClick={this.onBuyToneClicked} id="featured-buy-tone-card-option-div">
                                       <img  id="featured-buy-tone-card-option-icon" src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='22px' height='22px'/>                                   
                                              <label id="featured-buy-tone-card-option-label">{this.getContext().getResources().getString(Strings.buy)}</label>
                                      </div>}  
                                      
                                     {state.toneRowOptionsPrivilage.isSettings() && <div onClick={this.onSettingsClicked} id="featured-buy-tone-card-option-div">
                                     <img id="featured-settings-tone-card-option-icon"  src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='22px' height='22px'/>
                                     <label id="featured-buy-tone-card-option-label">{this.getContext().getResources().getString(Strings.settings)}</label>
                                     </div>}

                                     
                                 </> }
                                
                             </div>
                             <div id="button-col-div">
                                 {/* {
                                     <>
                                        <div style={{width:'20px', height:'20px',marginTop:'0px', marginLeft: !state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '20px' : "0px", marginRight:!state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '0px' : "7px"}}>
                                            {state.toneRowOptionsPrivilage.isGift() && <img title={props.context.getResources().getString(Strings.gift_a_friend)} onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} width='20px' height='20px' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>}
                                        </div>
                                        {state.toneRowOptionsPrivilage.isSettings() && <img style={{marginTop:"3px"}} onClick={this.onSettingsClicked} src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='20px' height='20px'/>}
                                        {state.toneRowOptionsPrivilage.isBuy() && <img style={{marginTop:"3px"}} title={props.context.getResources().getString(Strings.buytone)} onClick={this.onBuyToneClicked} src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='20px' height='20px'/>}
                                     </>
                                 } */}
                                  {<>
                                    {state.toneRowOptionsPrivilage.isGift() &&<div onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} id="featured-gift-tone-card-option-div">
                                             <img  id="featured-gift-tone-card-option-icon"   width='12px' height='12px' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>
                                            <label id="featured-gift-tone-card-option-label">{this.getContext().getResources().getString(Strings.gift)}</label>
                                      </div>}  
                                      {state.toneRowOptionsPrivilage.isBuy() &&  <div onClick={this.onBuyToneClicked} id="featured-buy-tone-card-option-div">
                                       <img  id="featured-buy-tone-card-option-icon" src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='12px' height='12px'/>                                   
                                              <label id="featured-buy-tone-card-option-label">{this.getContext().getResources().getString(Strings.buy)}</label>
                                      </div>}  
                                      
                                     {state.toneRowOptionsPrivilage.isSettings() && <div onClick={this.onSettingsClicked} id="featured-buy-tone-card-option-div">
                                     <img  id="featured-settings-tone-card-option-icon" src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='12px' height='12px'/>
                                     <label id="featured-buy-tone-card-option-label">{this.getContext().getResources().getString(Strings.settings)}</label>
                                     </div>}

                                     
                                 </> }
                              </div> 
                          </>         
                        }
                    </div>
                 </div>

            </div>
            </>
        );
    }

    getWebImageLoader(props: ToneCardComponentProps):JSX.Element
    {
        return(
            <>
            {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.evenImageLoaderCSSStyle} context={props.context}/>}
            </>
        );
    }

    getMobileImageLoader(props: ToneCardComponentProps):JSX.Element
    {
        return(
            <>
             {props.position % 2 === 0 ?<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageMobileLoaderCSSStyle} context={props.context}/> :<ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.evenMobileImageLoaderCSSStyle} context={props.context}/>}
            </>
        );
    }
    // getMobileView(props: ToneCardComponentProps, state: ToneCardComponentState, cssStyle: ToneCardCSSStyle)
    // {
    //     return (
    //         <>
    //         <div id="featured-tone-card-main-wrapper" key={props.position} style={props.cardStyle.getMobileToneWrapperCSSStyle(props.marginTop)} onMouseEnter={this.onHovered} onMouseLeave={this.onHoveredExit}>
    //             {state.isHovered && this.getMobileToneExtraOptionsPart(props.cardStyle, state, props)}
    //             {state.isActionHovered &&  this.getMobileToneOptionsPart(cssStyle, state)}
    //             {/* <img ref={(item: any) => {this.img = item;}} onError={this.onImgError} alt="" src={props.toneDto.getImgPath()} style={cssStyle.getImgCSSStyle()}/>    */}
    //             {
    //                 this.getMobileImageLoader(props)
    //             }    
    //             {state.toneRowOptionsPrivilage.isPlay() && <PlayerWithProgressComponent isAutoPlayRequired={props.isPlayInitial} position={props.position}  id={props.toneDto.getId()}  playIconName={"play.svg"} pauseIconName={"pause.svg"} playerCSSStyle={props.mobilePlayerCSSStyle !== undefined?props.mobilePlayerCSSStyle:props.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>}
    //             <div id={props.position+props.toneDto.getId()} style={props.cardStyle.getMobileDetailsDivCssStyle()}>
    //                {props.toneDto.getArtistName() !== "" && 
    //                <div style={props.cardStyle.getMobileTitleDivCSSStle()}>
    //                  <div style={{height: "20px", overflow: "hidden",marginTop:'7px',marginBottom:'3px'}}>
    //                     <label style={props.cardStyle.getMobileToneNameCSSStyle()}>{props.toneDto.getToneName()}</label>
    //                  </div>
    //                  <div style={{height: "15px", overflow: "hidden"}}>
    //                     <label style={cssStyle.getMobileArtistNameCSSStyle()}>{props.toneDto.getArtistName()}</label>
    //                  </div>
    //               </div>
    //                }
    //                {props.toneDto.getArtistName() === "" && 
    //                <div style={props.cardStyle.getMobileTitleDivCSSStle()}>
    //                  <div style={{height: "15px", overflow: "hidden",marginTop:'7px',marginBottom:'3px'}}>
    //                     <label style={props.cardStyle.getMobileToneNameCSSStyle()}>{props.toneDto.getToneName()}</label>
    //                  </div>
    //               </div>
    //                }
    //                 <div style={cssStyle.getMobileButtonCSSStyle()} >
    //                      <div style={{width:'12px', height:'100%', marginLeft: !state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '20px' : "0px", marginRight:!state.toneRowOptionsPrivilage.isBuy() && !state.toneRowOptionsPrivilage.isSettings() ? '0px' : "10px"}}>
    //                      {state.toneRowOptionsPrivilage.isGift() && <img title={props.context.getResources().getString(Strings.gift_a_friend)} onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.gift_a_friend))} width='100%' height='100%' src={this.getUIProps().context.getResources().getImage("gift_grey.svg")}/>}
    //                      {/* {this.listViewModel.getListOfDatas().length === 1 && state.toneRowOptionsPrivilage.isDelete() && <img  onClick={this.onDeleteClicked} src={this.getUIProps().context.getResources().getImage("delete_trash_gray.svg")} width='24px' height='100%'/>} */}
    //                      </div>
    //                      {state.toneRowOptionsPrivilage.isSettings() && <img style={{marginTop:"7px"}} onClick={this.onSettingsClicked} src={this.getUIProps().context.getResources().getImage("noun_setting.svg")} width='12px' height='100%'/>}
    //                      {state.toneRowOptionsPrivilage.isBuy() && <img style={{marginTop:"7px"}} title={props.context.getResources().getString(Strings.buytone)} onClick={this.onBuyToneClicked} src={this.getUIProps().context.getResources().getImage("grey_buy.svg")} width='12px' height='100%'/>}
    //                     {/* <ButtonComponent label={props.context.getResources().getString(Strings.buy_now)} style={new ToneCardButtonCSSStyleImpl(props.context)} onClick={() =>{}} context={props.context}/> */}
    //                 </div>
    //              </div>

    //         </div>
    //         </>
    //     );
    // }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getToneOptionsPart(cssStyle: ToneCardCSSStyle, state: ToneCardComponentState)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "featured-tone-card-onhover-even" : "featured-tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()}>
            <div style={{width:'100%', height:'30px',display:'flex'}}>
                
                    {/* {state.toneRowOptionsPrivilage.isLike() && 
                       <div id="featured-heart-div" style={cssStyle.getHeartDivCSSStyle()}>
                        <div style={{float: "left"}}>
                            <img style={{cursor:'no drop', paddingTop: "2px", paddingLeft: "10px", paddingRight: "4px"}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                        </div>
                        <div id="like-count-label" style={{}}> 
                        {" " + this.getLikeCount((this.getUIProps() as ToneCardComponentProps).toneDto)}
                        </div>
                        </div>
                    } */}
                   
                <div onMouseLeave={this.onActionHoveredExit} style={cssStyle.getDropDownSSStyle()}>
                    <DropDownListComponent cssStyle={new ToneOptionDropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={this.getUIProps().context}/>
                </div>
              </div>
              </div>);
    }

    getMobileToneOptionsPart(cssStyle: ToneCardCSSStyle, state: ToneCardComponentState)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "tone-card-onhover-even" : "tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()}>
            <div style={{width:'100%', height:'30px',display:'flex'}}>
                    
                    {/* {state.toneRowOptionsPrivilage.isLike() && 
                    <div id="featured-heart-div" style={cssStyle.getMobileHeartDivCSSStyle()}>
                     <img style={{cursor:'no drop'}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                     <div id="like-count-label" style={{}}>
                     {this.getLikeCount((this.getUIProps() as ToneCardComponentProps).toneDto) + " " + this.getUIProps().context.getResources().getString(Strings.likes)}
                     </div>
                     </div>
                     } */}
                 
                <div onMouseLeave={this.onActionHoveredExit} style={cssStyle.getMobileDropDownSSStyle()}>
                    <DropDownListComponent cssStyle={new ToneOptionDropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={this.getUIProps().context}/>
                </div>
              </div>
            </div>);
    }     

    getToneExtraOptionsPart(cssStyle: ToneCardCSSStyle,state: ToneCardComponentState, props:ToneCardComponentProps)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "featured-tone-card-onhover-even" : "featured-tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()} onClick={this.onActionHoveredExit}>
               <div style={{width:'100%', height:'30px',display:'flex', marginLeft:'auto', marginRight:'10px', marginTop:'10px',justifyContent:"flex-end"}}>
                   
                    {/* {state.toneRowOptionsPrivilage.isLike() && 
                        <div id="featured-heart-div" style={cssStyle.getHeartDivCSSStyle()}>
                        <div style={{float: "left"}}>
                            <img style={{cursor:'no drop', paddingTop: "2px", paddingLeft: "10px", paddingRight: "4px"}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                        </div>
                        <div id="like-count-label" style={{}}> 
                        {" " + this.getLikeCount(props.toneDto)}
                        </div>
                        </div>
                    } */}
                    

                            {state.toneRowOptionsPrivilage.isAction() && <div id="more-div" style={cssStyle.getExtraActionDivCSSStyle(state.toneRowOptionsPrivilage.isLike() ? "80%" : "100%")} onClick={this.onActionHovered}>
                            <img style={{height: "30px", width: "30px"}} src={this.getUIProps().context.getResources().getImage("action.svg")}/>
                               
                            </div>}
               </div> 
            </div>);
    }

    getMobileToneExtraOptionsPart(cssStyle: ToneCardCSSStyle,state: ToneCardComponentState, props:ToneCardComponentProps)
    {
        return (
            <div id={(this.getUIProps() as ToneCardComponentProps).position % 2 !== 0 ? "featured-tone-card-onhover-even" : "featured-tone-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()} onClick={this.onActionHoveredExit}>
               <div style={{width:'100%', height:'30px',display:'flex', marginLeft:'10px'}}>
                    
                    {/* {state.toneRowOptionsPrivilage.isLike() && 
                       <div id="featured-heart-div" style={cssStyle.getMobileHeartDivCSSStyle()}>
                        <div style={{float: "left"}}>
                            <img style={{cursor:"no drop", paddingTop: "2px", paddingLeft: "10px", paddingRight: "4px"}} src={this.getUIProps().context.getResources().getImage("heart.svg")}/>
                        </div>
                        <div id="like-count-label" style={{}}>
                        {" " + this.getLikeCount(props.toneDto)}
                        </div>
                        </div>
                    } */}
                    
                   
                          {/* {state.toneRowOptionsPrivilage.isTellAFriend() &&  <div style={cssStyle.getMobileAnnounceDivCSSStyle()}>
                            <img height="15px" width="90%" onClick={(e)=>this.showToneOptionsPopup(props.context.getResources().getString(Strings.tellafriend))} src={this.getUIProps().context.getResources().getImage("tellafriend.svg")}/>
                                <label style={{width:'100%',textAlign:'center',height:'10px',marginTop:'5px',color:'#FFFFFF',fontSize:'9px'}}>
                                    {this.getContext().getResources().getString(Strings.tellafriend)}
                                </label>
                            </div>} */}

                            {state.toneRowOptionsPrivilage.isAction() && <div id="more-div" style={cssStyle.getMobileExtraActionDivCSSStyle("60%")} onClick={this.onActionHovered}>
                            <img style={{height: "20px", width: "20px"}}  src={this.getUIProps().context.getResources().getImage("action.svg")}/>
                                {/* <div id="more-label" style={{}}>
                                    {this.getContext().getResources().getString(Strings.more)}
                                </div> */}
                            </div>}
               </div> 
              
            </div>);
    }  


     getLikeCount(toneDto: ToneDto): string
    {
        return toneDto.getLikeCount() === undefined ? "0" : toneDto.getLikeCount();
        // let formattedCount = this.getContext().getResources().getString(Strings.zero);

        // if(toneDto.getLikeCount() !== undefined)
        // {      
        //     if(+toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = toneDto.getLikeCount();
        //     }
        //     else if(+toneDto.getLikeCount() >= +this.getContext().getResources().getString(Strings.thousand) && +toneDto.getLikeCount() < +this.getContext().getResources().getString(Strings.thousand))
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.thousand)) + this.getContext().getResources().getString(Strings.K);
        //     }
        //     else if(+toneDto.getLikeCount() >= 100000 && +toneDto.getLikeCount() < 100000)
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/100000) + this.getContext().getResources().getString(Strings.K);
        //     }
        //     else
        //     {
        //         formattedCount = (+toneDto.getLikeCount()/+this.getContext().getResources().getString(Strings.million)) + this.getContext().getResources().getString(Strings.M);
        //     }

        //     return formattedCount;//.replace("."+ this.getContext().getResources().getString(Strings.zero), "");
        // }
        // else
        // {
        //     return formattedCount;
        // }
    }
    onPlayComplete(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }
   
    onPlayStop(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    protected onBuyToneClicked(): void 
    {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
        // <OTPVerificationComponent onClick={()=>''}  closePopup={this.closePopup} context={this.getContext()}/>);
            <BuyToneComponent showPopupOption={this.showToneOptionsPopup} getPopupWrapper={this.getPopUpWrapper} showPopup={this.showPopup}   toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

   
    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    onDeleteClicked()
    {
        this.showToneOptionsPopup(this.getUIProps().context.getResources().getString(Strings.delete));
    }
     showToneOptionsPopup(id:string):void
     {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        if(id === this.getUIProps().context.getResources().getString(Strings.gift_a_friend))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                // this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
                this.popUpComponent !== null &&  this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                    <GiftAFriendComponent showPopup={this.showPopup} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.wishlist))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
            (this.getUIComponentHandler() as ToneCardComponentHandler).addToWishlist();
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.shareatone))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <ShareToneComponent  toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.delete))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.showDeleteConfirmationPopUp(id);
            }
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.tellafriend))
        {
            if(!this.getUIProps().context.getUserContext().getIsLoggedIn())
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.login)} alertMessage={this.getContext().getResources().getString(Strings.authenticatemsg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.login} context={this.getUIProps().context}/>);
            }
            else 
            {
                this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <TellAFriendComponent showPopup={this.showPopup} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
            }
        }
       else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_nametune) + "_" + 
       this.getUIProps().context.getResources().getString(Strings.subscription))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <SubscriptionPlanComponent id={this.getUIProps().context.getResources().getString(Strings.buy_nametune)} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" + 
        this.getUIProps().context.getResources().getString(Strings.subscription))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <SubscriptionPlanComponent id={this.getUIProps().context.getResources().getString(Strings.buy_now)} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_now) + "_" +
        this.getUIProps().context.getResources().getString(Strings.otp_verification))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <OTPVerificationComponent toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} id={this.getUIProps().context.getResources().getString(Strings.buy_now)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.buy_nametune) + "_" +
        this.getUIProps().context.getResources().getString(Strings.otp_verification))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <OTPVerificationComponent toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto}  id={this.getUIProps().context.getResources().getString(Strings.buy_nametune)} showOptionsPopup={this.showToneOptionsPopup} showPopup={this.showPopup} headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else  if(id === this.getUIProps().context.getResources().getString(Strings.msisdn_validation))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <MSISDNValidationComponent showPopup={this.showToneOptionsPopup}  headerTitle={""} closePopup={this.closePopup} context={this.getUIProps().context}/>);
   
        }
        else if(id === this.getUIProps().context.getResources().getString(Strings.buytone))
        {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true,
                <BuyToneComponent showPopupOption={this.showToneOptionsPopup} getPopupWrapper={this.getPopUpWrapper} showPopup={this.showPopup}   toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
        }
     }

     showDeleteConfirmationPopUp(id: string)
     {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, 
            <DeleteConfirmComponent msg={this.getContext().getResources().getString(Strings.The_tune_will_be_deleted_and_all_related_settings_will_no_longer_be_available)} id={id}  headerTitle={this.getContext().getResources().getString(Strings.confirm)} closePopup={this.closePopup} context={this.getContext()} onConfirmClick={this.onDeleteConfirmed} onCancelClick={this.closePopup} />);
     }
     login()
     {
         this.closePopup();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
     }
     onDeleteConfirmed():void
     {
        (this.getUIComponentHandler() as ToneCardComponentHandler).onDeleteClicked();

     }

     
    showPopup(id:string,msg:string,type:AlertType):void
    {
        this.closePopup();
         if(type === AlertType.WARN)
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={(e)=>this.onTryAgainClick(id)} context={this.getUIProps().context}/>);
         }
         else if(id === this.getContext().getResources().getString(Strings.delete) && type === AlertType.SUCCESS)
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.onDeleteSuccess} onClick={this.onDeleteSuccess} context={this.getUIProps().context}/>);
         }
        
         else if((id === this.getContext().getResources().getString(Strings.buy_now) ||
         id === this.getContext().getResources().getString(Strings.otp_verification) || 
         id === this.getContext().getResources().getString(Strings.subscription)) 
         && type === AlertType.SUCCESS)
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.onBuySuccess} onClick={this.onBuySuccess} context={this.getUIProps().context}/>);
         }
        
         else 
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
         }
    }
    onDeleteSuccess():void
    {
        this.closePopup();
        (this.getUIProps() as ToneCardComponentProps).onDeleteClicked((this.getUIProps() as ToneCardComponentProps).toneDto);
        // this.props.onDeleteClicked(this.props.toneDto);

    }
    onBuySuccess():void
    {
        this.closePopup();

        console.log("------: " + this.getContext().getUserContext().getMsisdnB());

        if(!this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getUIComponentHandler() as ToneCardComponentHandler).doLogin(this.getContext().getUserContext().getMsisdnB());
        }
    }

    onTryAgainClick(id:string):void
    {
        this.closePopup();
        this.showToneOptionsPopup(id);
    }
    protected getPopUpWrapper():PopUpWrapperComponent
    {
        return this.popUpComponent;
    }
   
    protected onHovered(): void 
    {
        if(!(this.getUIState() as ToneCardComponentState).isActionHovered)
        {
            (this.getUIComponentHandler() as ToneCardComponentHandler).onHovered();
        }
    }
 
    protected onHoveredExit(): void 
    {
        (this.getUIComponentHandler() as ToneCardComponentHandler).onHoveredExit();
    }

    protected onActionHovered(): void 
    {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        (this.getUIComponentHandler() as ToneCardComponentHandler).onActionHovered();
    }
 
    protected onActionHoveredExit(): void 
    {
        (this.getUIComponentHandler() as ToneCardComponentHandler).onActionHoveredExit();
    }

    onSettingsClicked()
    {
        this.playerComponent !== null && this.playerComponent.onStopClicked();
        (this.getUIComponentHandler() as ToneCardComponentHandler).onSettingsClicked();
    }
    
    setPlayerWithProgress(audioPlayerWithProgress: AudioPlayerWithProgress)
    {
        this.audioPlayerWithProgress = audioPlayerWithProgress;
        if(this.playerComponent !== null)
        {
            this.playerComponent.updateProgress(0);
            this.playerComponent.onStopClicked();
            this.getContext().getPlayerManager().release();
            this.audioPlayerWithProgress.startProgress(undefined);
        }
        // this.playerComponent !== null && this.playerComponent.setPlayerWithProgress(this);
    }
  
    onPlayStart()
    {
        if(this.playerComponent !== null)
        {
    //         this.audioPlayerWithProgress.startProgress(this);
            this.playerComponent.playStart();
            // this.onPlayClicked();
        }
    }
    onPlayClicked(): void
    {
        this.initialStateOfTonePlaying = true;

        this.getContext().getPlayerManager()
                    .startPlay((this.getUIProps() as ToneCardComponentProps).toneDto.getToneUrl(), this);
        this.audioPlayerWithProgress.startProgress(this);
    }

    updateProgress(percentage: number): void 
    {
        this.playerComponent !== null && this.playerComponent.updateProgress(percentage);
    }

    protected onStopClicked(): void
    {
        this.initialStateOfTonePlaying = false;

        this.getContext().getPlayerManager().stopPlay();
    }

    protected onSelected()
    {
        (this.getUIState() as ToneCardComponentState).toneRowOptionsPrivilage.isToneSelect() &&
        (this.getUIComponentHandler() as ToneCardComponentHandler).onSelected();
    }

    onRowSelected(dropDownDto: DropDownDto): void 
    {
        this.showToneOptionsPopup(dropDownDto.getId());
    }

    private getListOfDropDown(context: BaseContext)
    {  
        let dropDownList = [];

        let state = (this.getUIState() as ToneCardComponentState);

        if(state.toneRowOptionsPrivilage.isTellAFriend())
        {
            let dropDown1 = new DropDownDtoImpl();
           dropDown1.setId(context.getResources().getString(Strings.tellafriend));
           dropDown1.setIconName(this.getContext().getResources().getString(Strings.tell_a_friend));
           dropDown1.setTitle(context.getResources().getString(Strings.tellafriend));

           dropDownList.push(dropDown1);
        }

        if(state.toneRowOptionsPrivilage.isAddWishlist())
       {
        let dropDown2 = new DropDownDtoImpl();
        dropDown2.setId(context.getResources().getString(Strings.wishlist));
        dropDown2.setIconName(this.getContext().getResources().getString(Strings.wish_list));
        dropDown2.setTitle(context.getResources().getString(Strings.wishlist));

        dropDownList.push(dropDown2);
        }
    
   
    //    if(state.toneRowOptionsPrivilage.isShare())
    //    {
    //         let dropDown3 = new DropDownDtoImpl();
    //         dropDown3.setId(context.getResources().getString(Strings.shareatone));
    //         dropDown3.setIconName(this.getContext().getResources().getString(Strings._share));
    //         dropDown3.setTitle(context.getResources().getString(Strings.share));

    //         dropDownList.push(dropDown3);
    //    }

       
       if(state.toneRowOptionsPrivilage.isDelete())
       {
            let dropDown3 = new DropDownDtoImpl();
            dropDown3.setId(context.getResources().getString(Strings.delete));
            dropDown3.setIconName(this.getContext().getResources().getString(Strings.delete_trash));
            dropDown3.setTitle(context.getResources().getString(Strings.delete));

            dropDownList.push(dropDown3);
       }

        return dropDownList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecardview.tsx